import slick from 'slick-carousel';

export default magazineSlider => {
	let $magazineList = $('.magazine-list');
	let currentSlidesToShow = 3.5;

	if ($magazineList.length < 1) {
		return false;
	}

	// Check if the list is included to news index.
	if ($magazineList.width() < 790) {
        currentSlidesToShow = 2.5;
	}

	let options = {
		slidesToShow: currentSlidesToShow,
		infinite: false,
        responsive: [
        	{
        		breakpoint: 372,
				settings: {
        			slidesToShow: 1.05,
					rows: 1,
				}
        	},
        	{
        		breakpoint: 430,
				settings: {
        			slidesToShow: 1.25,
					rows: 1,
				}
        	},
        	{
        		breakpoint: 500,
				settings: {
        			slidesToShow: 1.5,
					rows: 1,
				}
        	},
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1.75,
                    rows: 1,
                }
        	},
            {
                breakpoint: 666,
                settings: {
                    slidesToShow: 2.25,
                    rows: 1,
                }
        	},
            {
                breakpoint: 845,
                settings: {
                    slidesToShow: 2.5,
                    rows: 1,
                }
            }
		]
	};

	$magazineList.slick(options);
};
